import React from 'react'
import EyeIcon from 'assets/icons/eye-2-line-icon'
import CheckIcon from 'assets/icons/check-icon'
import ReturnDraftIcon from 'assets/icons/return-draft-icon'
import { SITE_STATUS_PROPOSED_ID, SITE_STATUS_SUBMITTED_EDIT_ONLY_ID } from '../siteStatuses'
import { getEditOnlyContext } from '../../utils/editOnlyContext'
import {
  createNavigateReviewDetails,
  createNavigateRfpStyleViewSite,
} from '../../utils/navigationHandlers'

function buildProposedOrSubmittedMenuItems(site, history, approveCallBack, declineCallBack, approveEditOnlyCallBack) {
  const { editOnlySite, editOnlySiteStatus } = getEditOnlyContext(site)

  return [
    {
      icon: <EyeIcon />,
      title: editOnlySiteStatus ? 'reviewEditOnlySite' : 'review',
      onClick: createNavigateReviewDetails(site, history, editOnlySite, editOnlySiteStatus),
    },
    {
      icon: <CheckIcon />,
      title: editOnlySiteStatus ? 'approveEditOnlySite' : 'approveSite',
      onClick: () => {
        if (editOnlySiteStatus && approveEditOnlyCallBack) {
          approveEditOnlyCallBack({ ...site, isApproved: true })
          return
        }
        approveCallBack(site)
      },
    },
    {
      icon: <ReturnDraftIcon />,
      title: editOnlySiteStatus ? 'returnToEditOnly' : 'returnToDraft',
      onClick: () => {
        if (editOnlySiteStatus && approveEditOnlyCallBack) {
          approveEditOnlyCallBack({ ...site, isApproved: false })
          return
        }
        declineCallBack(site)
      },
    },
  ]
}

function buildRfpBrcViewOnlyItem(site, history) {
  const { editOnlySite, editOnlySiteStatus } = getEditOnlyContext(site)
  return {
    icon: <EyeIcon />,
    title: 'viewSite',
    onClick: createNavigateRfpStyleViewSite(site, history, editOnlySite, editOnlySiteStatus),
  }
}

export function buildRfpAndBrcMenuItems({
  site,
  history,
  approveCallBack,
  declineCallBack,
  approveEditOnlyCallBack,
}) {
  if (
    site.SiteStatus.id === SITE_STATUS_PROPOSED_ID ||
    site.SiteStatus.id === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID
  ) {
    return buildProposedOrSubmittedMenuItems(
      site,
      history,
      approveCallBack,
      declineCallBack,
      approveEditOnlyCallBack
    )
  }
  return [buildRfpBrcViewOnlyItem(site, history)]
}

export function getRfpAndBrcActionMenuItems(...args) {
  const [site, history, approveCallBack, declineCallBack, , , approveEditOnlyCallBack] = args
  return buildRfpAndBrcMenuItems({
    site,
    history,
    approveCallBack,
    declineCallBack,
    approveEditOnlyCallBack,
  })
}
